/** T72 — Điều chỉnh tồn kho. Real /api/v1/inventory/adjustments. */
import { apiClient } from "./client";

export interface StockLine {
  inventoryId: string;
  medicineName: string;
  lotNumber: string | null;
  expiryDate: string | null;
  quantityOnHand: number;
}

export interface AdjustmentRow {
  medicineName: string;
  lotNumber: string | null;
  /** Signed: positive = nhập, negative = xuất. */
  quantity: number;
  reason: string | null;
  at: string;
}

export interface AdjustInput {
  inventoryId: string;
  /** Signed quantity: positive = nhập, negative = xuất. */
  quantity: number;
  reason: string;
}

export interface MedicineOption {
  id: string;
  name: string;
}

export interface ReceiveInput {
  medicineId: string;
  lotNumber: string;
  /** ISO date yyyy-MM-dd. */
  expiryDate: string;
  quantity: number;
  costPerUnitVnd?: number | null;
  notes?: string | null;
}

export const inventoryAdjustmentsApi = {
  stock(): Promise<StockLine[]> {
    return apiClient
      .get<StockLine[]>("/v1/inventory/adjustments/stock")
      .then((r) => r.data);
  },
  history(): Promise<AdjustmentRow[]> {
    return apiClient
      .get<AdjustmentRow[]>("/v1/inventory/adjustments")
      .then((r) => r.data);
  },
  adjust(body: AdjustInput): Promise<void> {
    return apiClient.post("/v1/inventory/adjustments", body).then(() => undefined);
  },
  receive(body: ReceiveInput): Promise<void> {
    return apiClient
      .post("/v1/inventory/adjustments/receive", body)
      .then(() => undefined);
  },
  medicines(): Promise<MedicineOption[]> {
    return apiClient
      .get<{ content: Array<{ id: string; name: string }> }>("/v1/medicines", {
        params: { size: 500, visibleOnly: false },
      })
      .then((r) => r.data.content.map((m) => ({ id: m.id, name: m.name })));
  },
};

export const inventoryAdjustmentsQueryKeys = {
  stock: () => ["inventory-adjust-stock"] as const,
  history: () => ["inventory-adjust-history"] as const,
  medicines: () => ["inventory-adjust-medicines"] as const,
};
